import React from "react";
import PropTypes from "prop-types";
import { easilGrayXDark } from "./style.module.css";

const OutlineIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <rect
        width="16"
        height="2"
        x="4"
        y="5.5"
        fill={color || easilGrayXDark}
        rx="1"
      />
      <rect
        width="16"
        height="3"
        x="4"
        y="9.5"
        fill={color || easilGrayXDark}
        rx="1"
      />
      <rect
        width="16"
        height="4"
        x="4"
        y="14.5"
        fill={color || easilGrayXDark}
        rx="1"
      />
    </g>
  </svg>
);
OutlineIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default OutlineIcon;
